import type { IAddress, ICommonUserProps } from '@/types';
import type { FieldErrors } from 'react-hook-form';

export function pathJoin(parts: string[], separator = '/'): string {
  const replace = new RegExp(separator + '{1,}', 'g');
  return parts.join(separator).replace(replace, separator);
}

export const getFullName = (user: ICommonUserProps): string => `${user.firstName} ${user.lastName}`;
export const getFullAddress = <T extends IAddress>(address?: T): string =>
  address
    ? `${address.streetAddress}, ${address.zipCode}, ${address.city}, ${address.countryCode}`
    : '';

export const hasEmptyFields = <T extends object, TK extends keyof T>(
  obj: T,
  keys?: TK[]
): boolean =>
  (keys ?? Object.keys(obj)).some((f) => {
    const objValue = obj[f as TK];
    return Array.isArray(objValue) ? objValue.length === 0 : !objValue;
  });

// eslint-disable-next-line @typescript-eslint/require-await
export const getCaptchaToken = async (): Promise<string> =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
  (window as unknown as IWindow).grecaptcha.execute(
    process.env.REACT_APP_RECAPTCHA_SITE_KEY as string,
    {
      action: 'submit',
    }
  );

export const hasFormAnyError = (errors: FieldErrors | undefined): boolean =>
  Object.values(errors ?? {}).some(Boolean);

export const scrollToTop = (): void => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

export const formatDate = (str: string | undefined, locale: string): string => {
  if (!str) return '';
  const date = new Date(str);
  return date
    .toLocaleDateString(locale, { year: 'numeric', month: 'numeric', day: 'numeric' })
    .replaceAll('/', '.');
};
